import apiClient from './api';
import { NoteCreateDTO } from '../models/note';

// Create note
export const createNote = async (id: number, note: NoteCreateDTO) => {
  const response = await apiClient.post(`/note/module/${id}`, note);
  return response.data;
};

// Update note
export const updateNote = async (id: number, note: NoteCreateDTO) => {
  const response = await apiClient.put(`/note/${id}`, note);
  return response.data;
};

// Delete note
export const deleteNote = async (id: number) => {
  const response = await apiClient.delete(`/note/${id}`);
  return response.data;
};

// Get single note
export const getNote = async (id: number) => {
  const response = await apiClient.get(`/note/${id}`);
  return response.data;
};

// Get notes by module
export const getNotes = async (id: number) => {
  const response = await apiClient.get(`/note/module/${id}`);
  return response.data;
};

// Get notes by user modules with filters
export const getNotesByUserModules = async (listIndex?: number, filters?: any) => {
  const searchParams = new URLSearchParams();

  if (filters) {
    for (const prop in filters) {
      if (Array.isArray(filters[prop])) {
        filters[prop].forEach((p: any) => {
          const val = p?.toString() ?? '';
          if (val !== '') searchParams.append(prop, val);
        });
      } else {
        const val = filters[prop]?.toString() ?? '';
        if (val !== '') searchParams.append(prop, val);
      }
    }
  }

  if (listIndex !== undefined) {
    searchParams.append('listIndex', listIndex.toString());
  }

  const response = await apiClient.get(`/note/`, { params: searchParams });
  return response.data;
};

// Get note history
export const getNoteHistory = async (id: number) => {
  const response = await apiClient.get(`/note/history/${id}`);
  return response.data;
};

// Get notes history by module
export const getNotesHistoryByModule = async (id: number) => {
  const response = await apiClient.get(`/note/history/module/${id}`);
  return response.data;
};